(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fishing-set-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fishing-set-finder')) {
    customElements.define('fishing-set-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          this.observer.observe(this.track);
          return;
        }
        this.initialized = true;
        this.track = this.querySelector('.jk-fishing__cards');
        this.cards = [...this.querySelectorAll('.jk-fishing__card')];
        this.filters = [...this.querySelectorAll('[data-filter]')];
        this.selectedSpecies = new Set();
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.counter = this.querySelector('.jk-fishing__count');
        this.querySelector('.jk-fishing__filters').hidden = false;
        this.querySelector('.jk-fishing__arrows').hidden = false;
        this.filters.forEach(button => button.addEventListener('click', () => this.filter(button.dataset.filter)));
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
          const card = this.cards.find(item => !item.hidden);
          const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
          this.track.scrollBy({ left: Number(button.dataset.direction) * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }));
        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        this.observer = new ResizeObserver(() => this.updateArrows());
        this.observer.observe(this.track);
        this.filter('all');
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      filter(species) {
        if (species === 'all') {
          this.selectedSpecies.clear();
        } else if (this.selectedSpecies.has(species)) {
          this.selectedSpecies.delete(species);
        } else {
          this.selectedSpecies.add(species);
        }
        let count = 0;
        this.cards.forEach(card => {
          card.hidden = this.selectedSpecies.size > 0 && !card.dataset.species.split(',').some(fish => this.selectedSpecies.has(fish));
          if (!card.hidden) count++;
          card.querySelectorAll('a[href]').forEach(link => {
            const url = new URL(link.href, location.origin);
            const fish = card.dataset.species.split(',').filter(value => this.selectedSpecies.has(value));
            if (fish.length) url.searchParams.set('jk_fish', fish.join(','));
            else url.searchParams.delete('jk_fish');
            link.href = url.pathname + url.search + url.hash;
          });
        });
        this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === 'all' ? this.selectedSpecies.size === 0 : this.selectedSpecies.has(button.dataset.filter))));
        this.counter.textContent = this.counter.dataset.countTemplate.replace('[count]', String(count));
        this.querySelector('.jk-fishing__empty').hidden = count !== 0;
        this.track.scrollLeft = 0;
        this.updateArrows();
      }
      updateArrows() {
        this.querySelector('.jk-fishing__arrows').hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        this.previous.disabled = this.track.scrollLeft < 6;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
